var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2003_2083",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2003_2083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1354 10.0833C11.5174 10.0833 10.9931 10.2997 10.5625 10.7325C10.1319 11.1653 9.91667 11.6907 9.91667 12.3087C9.91667 12.9271 10.1331 13.4515 10.5658 13.8821C10.9986 14.3126 11.524 14.5279 12.1421 14.5279C12.7604 14.5279 13.2849 14.3115 13.7154 13.8787C14.146 13.446 14.3613 12.9204 14.3613 12.3021C14.3613 11.684 14.1449 11.1597 13.7121 10.7291C13.2793 10.2986 12.7538 10.0833 12.1354 10.0833ZM12.1354 27.1387C11.5174 27.1387 10.9931 27.3551 10.5625 27.7879C10.1319 28.2207 9.91667 28.7462 9.91667 29.3646C9.91667 29.9826 10.1331 30.5069 10.5658 30.9375C10.9986 31.368 11.524 31.5833 12.1421 31.5833C12.7604 31.5833 13.2849 31.3669 13.7154 30.9341C14.146 30.5014 14.3613 29.976 14.3613 29.3579C14.3613 28.7396 14.1449 28.2151 13.7121 27.7846C13.2793 27.354 12.7538 27.1387 12.1354 27.1387ZM6.5 5.02789H33.4721C33.926 5.02789 34.294 5.16901 34.5763 5.45123C34.8588 5.73373 35 6.1047 35 6.56414V17.9166C35 18.3966 34.8588 18.799 34.5763 19.1237C34.294 19.4487 33.926 19.6112 33.4721 19.6112H6.5C6.06472 19.6112 5.70597 19.4487 5.42375 19.1237C5.14125 18.799 5 18.3966 5 17.9166V6.56414C5 6.1047 5.14125 5.73373 5.42375 5.45123C5.70597 5.16901 6.06472 5.02789 6.5 5.02789ZM6.5 22.0554H33.3612C33.7962 22.0554 34.1782 22.2244 34.5071 22.5625C34.8357 22.9005 35 23.2966 35 23.7508V34.9721C35 35.4998 34.8357 35.9143 34.5071 36.2154C34.1782 36.5162 33.7962 36.6666 33.3612 36.6666H6.63875C6.18514 36.6666 5.79861 36.5162 5.47917 36.2154C5.15972 35.9143 5 35.4998 5 34.9721V23.7508C5 23.2966 5.14125 22.9005 5.42375 22.5625C5.70597 22.2244 6.06472 22.0554 6.5 22.0554Z",
    fill: "#819DF9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.654346053690b7fc6cfa008d410ab608.svg";
export { ForwardRef as ReactComponent };